import {
  Action,
  configureStore,
  ThunkAction,
} from '@reduxjs/toolkit';

import activityReducer from './activityReducer';
import appReducer from './appReducer';
import chatReducer from './chatReducer';
import communityMessageReducer from './communityMessageReducer';
import communityReducer from './communityReducer';
import mangoReducer from './mangoReducer';
import mediaReducer from './mediaReducer';
import platformIntegrationReducer from './platformIntegration';
import tqConnectServiceRequestReducer from './tqConnectServiceRequestReducer';
import tqConnectUserReducer from './tqConnectUserReducer';
import userReducer from './userReducer';

export const store = configureStore({
  reducer: {
    app: appReducer,
    activity: activityReducer,
    user: userReducer,
    media: mediaReducer,
    chat: chatReducer,
    mango: mangoReducer,
    community: communityReducer,
    communityMessage: communityMessageReducer,
    platformIntegration: platformIntegrationReducer,
    tqConnectServiceRequest: tqConnectServiceRequestReducer,
    tqConnectUser: tqConnectUserReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({ serializableCheck: false }),
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
